export default __webpack_public_path__ + "static/media/search-no-results-1.5x.fa2b8979.png";